import Vue from 'vue'
import Router from 'vue-router'

const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  linkActiveClass: 'active',
  routes: [{
    path: '/',
    name: 'home',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/home")
  },
  // {
  //   path: '/',
  //   name: 'newhome',
  //   meta: { navShow: true, index: 1, keepAlive: true },
  //   component: () => import("@/views/newhome")
  // },
  // {
  //   path: '/newhome_alone',
  //   name: 'newhome_alone',
  //   meta: { navShow: true, index: 1, keepAlive: true },
  //   component: () => import("@/views/newhome_alone")
  // },
  {
    path: '/activityCenter',
    name: 'activityCenter',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/activityCenter")
  },
  {
    path: '/classify',
    name: 'classify',
    meta: {
      navShow: true,
      index: 2,
      keepAlive: true,
      isUseCache: false,
    },
    component: () => import("@/views/classify"),
  },
  {
    path: '/classify_alone',
    name: 'classify_alone',
    meta: {
      navShow: true,
      index: 2,
      keepAlive: true,
      isUseCache: false,
    },
    component: () => import("@/views/classify_alone"),
  },
  // 品牌分类页
  {
    path: '/brandClassify',
    name: 'brandClassify',
    meta: {
      navShow: true,
      index: 1,
      keepAlive: true,
      isUseCache: false,
    },
    component: () => import("@/views/brandClassify"),
  },
  // 品牌分类页（独立版）
  {
    path: '/brandClassify_alone',
    name: 'brandClassify_alone',
    meta: {
      navShow: true,
      index: 1,
      keepAlive: true,
      isUseCache: false,
    },
    component: () => import("@/views/brandClassify_alone"),
  },
  {
    path: '/found',
    name: 'found',
    meta: {
      navShow: true,
      index: 3,
      keepAlive: true,
    },
    component: () => import("@/views/found")
  },
  {
    path: '/newPublish',
    name: 'newPublish',
    meta: {
      navShow: true,
      index: 1,
      keepAlive: true
    },
    component: () => import("@/views/newPublish")
  },
  {
    path: '/bucket',
    name: 'bucket',
    meta: {
      navShow: true,
      index: 4
    },
    component: () => import("@/views/bucket")
  },
  {
    path: '/bucket_alone',
    name: 'bucket_alone',
    meta: {
      navShow: true,
      index: 4
    },
    component: () => import("@/views/bucket_alone")
  },
  {
    path: '/mine',
    name: 'mine',
    meta: {
      navShow: true,
      index: 5
    },
    component: () => import("@/views/mine")
  },
  {
    path: '/mine_alone',
    name: 'mine_alone',
    meta: {
      navShow: true,
      index: 5
    },
    component: () => import("@/views/mine_alone")
  },
  {
    path: '/chooseStore',
    name: 'chooseStore',
    meta: {
    },
    component: () => import("@/views/chooseStore")
  },
  {
    path: '/goods/:keyword',
    name: 'goods',
    meta: {
      navShow: true,
      index: 1,
      keepAlive: true,
      isUseCache: false
    },
    component: resolve => (require(["@/views/goods"], resolve))
  },
  {
    path: '/goods_alone/:keyword',
    name: 'goods_alone',
    meta: {
      navShow: true,
      index: 1,
      keepAlive: true,
      isUseCache: false
    },
    component: () => import("@/views/goods_alone")
  },
  {
    path: '/reportIC',
    name: 'reportIC',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/reportIC")
  },
  {
    path: '/commodyList/:id/:goodsPromoId',
    name: 'commodyList',
    meta: {
      navShow: true,
      index: 2,
      keepAlive: true
    },
    component: () => import("@/views/commodyList")
  },
  {
    path: '/commodyList_alone/:id/:goodsPromoId',
    name: 'commodyList_alone',
    meta: {
      navShow: true,
      index: 2,
      keepAlive: true
    },
    component: () => import("@/views/commodyList_alone")
  },
  {
    path: '/commody/:id/:goodsPromoId',
    name: 'commody',
    meta: {
      navShow: true,
      index: 2,
      keepAlive: true
    },
    component: () => import("@/views/commody")
  },
  {
    path: '/commody_alone/:id/:goodsPromoId',
    name: 'commody_alone',
    meta: {
      navShow: true,
      index: 2,
      keepAlive: true
    },
    component: () => import("@/views/commody_alone")
  },
  {
    path: '/order/:active',
    name: 'order',
    meta: {
      navShow: true,
      index: 5
    },
    component: () => import("@/views/order")
  },
  {
    path: '/order_alone/:active',
    name: 'order_alone',
    meta: {
      navShow: true,
      index: 5
    },
    component: () => import("@/views/order_alone")
  },
  {
    path: '/presell',
    name: 'presell',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/presell"),
  },
  {
    path: '/presellOrder',
    name: 'presellOrder',
    // meta: { navShow: true, index: 1, keepAlive: true, isUseCache: false, },
    component: () => import("@/views/presellOrder"),
  },
  {
    path: '/presellOrderDetail/:sheetNo',
    name: 'presellOrderDetail',
    component: () => import("@/views/presellOrderDetail"),
  },
  {
    path: '/orderDetail/:sheetNo/:active',
    name: 'orderDetail',
    component: () => import("@/views/orderDetail")
  },
  {
    path: '/orderDetail_alone/:sheetNo/:active',
    name: 'orderDetail_alone',
    component: () => import("@/views/orderDetail_alone")
  },
  {
    path: '/goodsDetail/:goodsId/:companyId/:userId/:isDock',
    name: 'goodsDetail',
    component: () => import("@/views/goodsDetail")
  },
  {
    path: '/goodsDetail_alone/:goodsId',
    name: 'goodsDetail_alone',
    component: () => import("@/views/goodsDetail_alone")
  },
  {
    path: '/login',
    name: 'login',
    component: () => import("@/views/login")
  },
  {
    path: '/warehouseList',
    name: 'warehouseList',
    component: () => import("@/views/warehouseList")
  },
  {
    path: '/intentionOrder',
    name: 'intentionOrder',
    component: () => import("@/views/intentionOrder")
  },
  {
    path: '/pushOrder',
    name: 'pushOrder',
    component: () => import("@/views/pushOrder")
  },
  {
    path: '/intentionOrderDetail/:orderNo',
    name: 'intentionOrderDetail',
    component: () => import("@/views/intentionOrderDetail")
  },
  {
    path: '/pushOrderDetail/:orderNo',
    name: 'pushOrderDetail',
    component: () => import("@/views/pushOrderDetail")
  },
  {
    path: '/selectLogin',
    name: 'selectLogin',
    component: () => import("@/views/selectLogin")
  },
  {
    path: '/register',
    name: 'register',
    component: () => import("@/views/register")
  },
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: () => import("@/views/forgotPassword")
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import("@/views/agreement")
  },
  {
    path: '/collection',
    name: 'collection',
    component: () => import("@/views/collection")
  },
  {
    path: '/collection_alone',
    name: 'collection_alone',
    component: () => import("@/views/collection_alone")
  },
  {
    path: '/footprint',
    name: 'footprint',
    component: () => import("@/views/footprint")
  },
  {
    path: '/footprint_alone',
    name: 'footprint_alone',
    component: () => import("@/views/footprint_alone")
  },
  {
    path: '/coupon',
    name: 'coupon',
    component: () => import("@/views/coupon")
  },
  {
    path: '/couponDetail/:couponId/:type',
    name: 'couponDetail',
    component: () => import("@/views/couponDetail")
  },
  {
    path: '/hot',
    name: 'hot',
    meta: {
      navShow: true,
      index: 1,
      keepAlive: true
    },
    component: () => import("@/views/hot")
  },
  {
    path: '/hot_alone',
    name: 'hot_alone',
    meta: {
      navShow: true,
      index: 1,
      keepAlive: true,
      isUseCache: true,
    },
    component: () => import("@/views/hot_alone")
  },
  {
    path: '/specialList',
    name: 'specialList',
    meta: {
      navShow: true,
      index: 1,
      keepAlive: true
    },
    component: () => import("@/views/specialList")
  },
  {
    path: '/specialList_alone',
    name: 'specialList_alone',
    meta: {
      navShow: true,
      index: 1,
      keepAlive: true
    },
    component: () => import("@/views/specialList_alone")
  },
  {
    path: '/fullReduction_alone/:id',
    name: 'fullReduction_alone',
    meta: {
      keepAlive: true
    },
    component: () => import("@/views/fullReduction_alone")
  },
  {
    path: '/seckill',
    name: 'seckill',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/seckill")
  },
  {
    path: '/seckill_alone',
    name: 'seckill_alone',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/seckill_alone")
  },
  {
    path: '/group',
    name: 'group',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/group")
  },
  {
    path: '/group_alone',
    name: 'group_alone',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/group_alone")
  },
  {
    path: '/promotion',
    name: 'promotion',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/promotion")
  },
  {
    path: '/promotion_alone',
    name: 'promotion_alone',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/promotion_alone")
  },
  {
    path: '/combination',
    name: 'combination',
    meta: {
      navShow: true,
      index: 1,
      keepAlive: true
    },
    component: () => import("@/views/combination")
  },
  {
    path: '/combination_alone',
    name: 'combination_alone',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/combination_alone")
  },
  {
    path: '/combineDetail/:goodsId/:packId',
    name: 'combineDetail',
    // meta: { navShow: true, index: 1 },
    component: () => import("@/views/combineDetail")
  },
  {
    path: '/combineDetail_alone/:packId',
    name: 'combineDetail_alone',
    // meta: { navShow: true, index: 1 },
    component: () => import("@/views/combineDetail_alone")
  },
  {
    path: '/integralMall',
    name: 'integralMall',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/integralMall")
  },
  {
    path: '/integralOrder',
    name: 'integralOrder',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/integralOrder")
  },
  {
    path: '/luckDraw',
    name: 'luckDraw',
    component: () => import("@/views/luckDraw")
  },
  {
    path: '/retailBonus',
    name: 'retailBonus',
    component: () => import("@/views/retailBonus")
  },
  {
    path: '/retailBonusOrder',
    name: 'retailBonusOrder',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/retailBonusOrder")
  },
  {
    path: '/retailBonusOrderDetail',
    name: 'retailBonusOrderDetail',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/retailBonusOrderDetail")
  },
  {
    path: '/brandSinks',
    name: 'brandSinks',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/brandSinks")
  },
  {
    path: '/brandSinks_alone',
    name: 'brandSinks_alone',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/brandSinks_alone")
  },
  {
    path: '/brandSinksDetail/:brandId',
    name: 'brandSinksDetail',
    component: () => import("@/views/brandSinksDetail")
  },
  {
    path: '/brandSinksDetail_alone/:brandRemitId',
    name: 'brandSinksDetail_alone',
    component: () => import("@/views/brandSinksDetail_alone")
  },
  {
    path: '/settlement/:bucketIdList/:brandRemitAmount/:brandRemit/:finalRule/:selectCoupon/:isGoodsPromotion/:isBrandRemit',
    name: 'settlement',
    component: () => import("@/views/settlement")
  },
  {
    path: '/settlement_alone/:bucketParams',
    name: 'settlement_alone',
    component: () => import("@/views/settlement_alone")
  },
  {
    path: '/settlementbg/:sheetNo',
    name: 'settlementbg',
    component: () => import("@/views/settlementbg")
  },
  {
    path: '/settlement_warehouseDivision/',
    name: 'settlement_warehouseDivision',
    component: () => import("@/views/settlement_warehouseDivision")
  },
  {
    path: '/success',
    name: 'success',
    component: () => import("@/views/success")
  },
  {
    path: '/success_alone',
    name: 'success_alone',
    component: () => import("@/views/success_alone")
  },
  {
    path: '/personal',
    name: 'personal',
    component: () => import("@/views/personal")
  },
  {
    path: '/addressManagement',
    name: 'addressManagement',
    component: () => import("@/views/addressManagement")
  },
  {
    path: '/editAddr/:addrInfo',
    name: 'editAddr',
    component: () => import("@/views/editAddr")
  },
  {
    path: '/editAddr_dock/:addrInfo',
    name: 'editAddr_dock',
    component: () => import("@/views/editAddr_dock")
  },
  {
    path: '/voucherCenter',
    name: 'voucherCenter',
    meta: {
      navShow: true,
      index: 1
    },
    component: () => import("@/views/voucherCenter")
  },
  {
    path: '/changePwd',
    name: 'changePwd',
    component: () => import("@/views/changePwd")
  },
  {
    path: '/refund',
    name: 'refund',
    component: () => import("@/views/refund")
  },
  {
    path: '/refund_alone/:keyword',
    name: 'refund_alone',
    component: () => import("@/views/refund_alone")
  },
  {
    path: '/refundBuck_alone',
    name: 'refundBuck_alone',
    component: () => import("@/views/refundBuck_alone")
  },
  {
    path: '/refundOrderSucc_alone',
    name: 'refundOrderSucc_alone',
    component: () => import("@/views/refundOrderSucc_alone")
  },
  {
    path: '/refundOrder',
    name: 'refundOrder',
    component: () => import("@/views/refundOrder")
  },
  {
    path: '/refundDetail',
    name: 'refundDetail',
    component: () => import("@/views/refundDetail")
  },
  {
    path: '/refundDetail_alone/:refundOrderNo',
    name: 'refundDetail_alone',
    component: () => import("@/views/refundDetail_alone")
  },
  {
    path: '/kf',
    name: 'kf',
    component: () => import("@/views/kf")
  },
  {
    path: '/customerAccount_alone',
    name: 'customerAccount_alone',
    component: () => import("@/views/customerAccount_alone")
  },
  {
    path: '*',
    name: "notFound",
    component: () => import("@/views/notFound")
  },
  {
    path: '/netError',
    name: 'netError',
    component: () => import("@/views/netError")
  },
  {
    path: '/page',
    name: 'page',
    component: () => import("@/views/page")
  },
  {
    path: '/orderBlank',
    name: 'orderBlank',
    component: () => import("@/views/orderBlank")
  },
  {
    path: '/orderBlankDetail/:sheetNo',
    name: 'orderBlankDetail',
    component: () => import("@/views/orderBlankDetail")
  },

  {
    path: '/orderBlankInfo',
    name: 'orderBlankInfo',
    component: () => import("@/views/orderBlankInfo")
  },
  {
    path: '/orderCheck',
    name: 'orderCheck',
    component: () => import("@/views/orderCheck")
  },
  {
    path: '/orderCheckInfo/:sheetNo/:scanCode',
    name: 'orderCheckInfo',
    component: () => import("@/views/orderCheckInfo")
  },
  {
    path: '/orderCheckDetail/:sheetNo',
    name: 'orderCheckDetail',
    component: () => import("@/views/orderCheckDetail")
  },
  {
    path: '/industryClassify',
    name: 'industryClassify',
    meta: {
      navShow: true,
      index: 2,
      isUseCache: false,
      keepAlive: true,
    },
    component: () => import("@/views/industryClassify")
  },
  {
    path: '/investMoney',
    name: 'investMoney',
    component: () => import("@/views/investMoney")
  },
  {
    path: '/investMoney_alone',
    name: 'investMoney_alone',
    component: () => import("@/views/investMoney_alone")
  },
  {
    path: '/investRecord_alone',
    name: 'investRecord_alone',
    component: () => import("@/views/investRecord_alone")
  },
  {
    path: '/investMoneyInfo_alone/:payWays/:amount',
    name: 'investMoneyInfo_alone',
    component: () => import("@/views/investMoneyInfo_alone")
  },
  {
    path: '/investMoneyInfo/:payWays/:amount',
    name: 'investMoneyInfo',
    component: () => import("@/views/investMoneyInfo")
  },
  {
    path: '/investRecord',
    name: 'investRecord',
    component: () => import("@/views/investRecord")
  },
  {
    path: '/WXinvestMoney',
    name: 'WXinvestMoney',
    component: () => import("@/views/WXinvestMoney")
  },
  {
    path: '/intelligentGoodsReporte',
    name: 'intelligentGoodsReporte',
    component: () => import("@/views/intelligentGoodsReporte")
  },
  {
    path: '/messageNotification',
    name: 'messageNotification',
    component: () => import("@/views/messageNotification")
  },
  {
    path: '/contentGoods/:keyword',
    name: 'contentGoods',
    component: () => import("@/views/contentGoods")
  },
  {
    path: '/txMap',
    name: 'txMap',
    component: () => import("@/views/txMap")
  },
  // {
  //   path: '/newLogin',
  //   name: 'newLogin',
  //   component: () => import("@/views/newLogin")
  // },
  // {
  //   path: '/newRegister',
  //   name: 'newRegister',
  //   component: () => import("@/views/newRegister")
  // }
  // {
  //   path: '/new_mine_alone',
  //   name: 'new_mine_alone',
  //   component: () => import("@/views/new_mine_alone")
  // },
  {
    path: '/new_personal',
    name: 'new_personal',
    component: () => import("@/views/new_personal")
  },
  {
    path: '/new_goodsDetail/:goodsId/:companyId/:userId/:isDock',
    name: 'new_goodsDetail',
    component: () => import("@/views/new_goodsDetail")
  },
  {
    path: '/new_addressManagement',
    name: 'new_addressManagement',
    component: () => import("@/views/new_addressManagement")
  },
  {
    path: '/new_editAddr_dock',
    name: 'new_editAddr_dock',
    component: () => import("@/views/new_editAddr_dock")
  },
  {
    path: '/new_settlement/:bucketIdList/:brandRemitAmount/:brandRemit/:finalRule/:selectCoupon',
    name: 'new_settlement',
    component: () => import("@/views/new_settlement")
  },
  {
    path: '/new_settlementbg/:sheetNo',
    name: 'new_settlementbg',
    component: () => import("@/views/new_settlementbg")
  },
  {
    path: '/examinGoodsOrderList/:keyWord',
    name: 'examinGoodsOrderList',
    component: () => import("@/views/examinGoodsOrderList")
  },
  {
    path: '/examinGoods/:outId/:keyWord',
    name: 'examinGoods',
    component: () => import("@/views/examinGoods")
  },
  {
    path: '/examinGoodsDetail/:outId',
    name: 'examinGoodsDetail',
    component: () => import("@/views/examinGoodsDetail")
  },
  {
    path: '/payCode_alone/:sheetNo',
    name: 'payCode_alone',
    component: () => import("@/views/payCode_alone")
  },
  {
    path: '/examinGoodsOrderList_dock/:keyWord',
    name: 'examinGoodsOrderList_dock',
    component: () => import("@/views/examinGoodsOrderList_dock")
  },
  {
    path: '/examinGoods_dock/:outId/:keyWord',
    name: 'examinGoods_dock',
    component: () => import("@/views/examinGoods_dock")
  },
  {
    path: '/examinGoodsDetail_dock/:outId',
    name: 'examinGoodsDetail_dock',
    component: () => import("@/views/examinGoodsDetail_dock")
  },
  {
    path: '/found_old_dock',
    name: 'found_old_dock',
    component: () => import("@/views/found_old_dock")
  },
  {
    path: '/chooseBindStore',
    name: 'chooseBindStore',
    component: () => import("@/views/chooseBindStore")
  },
  ]
})
// 全局路由守卫
router.beforeEach(async (to, from, next) => {
  next() // 必须使用 next ,执行效果依赖 next 方法的调用参数
  let userKey = await router.app.$api.common.getUserKey()
  let userInfo = router.app.$cookies.get(userKey)
  if (to.name == "login" || to.name == "selectLogin" || to.name == "warehouseList") {
    return
  }
  if (router.app.$api.common.isEmpty(userInfo)) {
    console.log("当前客户不存在！！！")
  } else {
    console.log("当前客户存在！！！")
    if (userInfo.isDock) { //对接版才需要判断是否已登录
      let params = {
        userId: userInfo.userId
      }
      router.app.$api.user.getUserIsLogined(params).then(res => {
        let result = res.data
        if (result.status == 200) {
          localStorage.setItem('getUserIsLogined', JSON.stringify(result.data))
          let isLogined = result.data.isLogined
          let isAllowLogin = result.data.isAllowLogin
          if (!isAllowLogin) {
            router.app.$cookies.remove(userKey)
            router.app.$messagebox({
              title: "提示",
              message: "您的账户已禁止线上登录，请联系总部启用！",
              showConfirmButton: true,
              type: "warning",
              duration: 2000,
              onClose: () => {
                router.app.$api.user
                  .logout(params)
                  .then(res => {
                    let result = res.data
                    console.log("退出登录请求返回参数：" + JSON.stringify(result))
                    //确认前往登录
                    router.app.$router.push({
                      name: "login"
                    })
                  })
                  .catch(err => { })
              },
            })
            return
          }
          // if (!isLogined) {
          //   router.app.$cookies.remove("user");
          //   router.app.$messagebox({
          //     title: "提示",
          //     message: "您的登录已过期，请重新登录！",
          //     showConfirmButton: true,
          //     type: "warning",
          //     duration: 2000,
          //     onClose: () => {
          //       console.log("重新登录！！！");
          //       //确认前往登录
          //       router.app.$router.push({ name: "login" });
          //     },
          //   });
          //   return;
          // }
        }
      }).catch(err => {

      })
    } else { //独立版 判断客户是否已经删除、停用
      let params = {
        userId: userInfo.userId
      }
      router.app.$api.user.getUserInfoAloneStatus(params).then(res => {
        let result = res.data
        if (result.status == 200) {
          localStorage.setItem('isPosStore', result.data.isPosStore)
          localStorage.setItem('userLevelId', result.data.userLevelId)
          if (!result.data.isEnable) {
            router.app.$cookies.remove(userKey)
            router.app.$messagebox({
              title: "提示",
              message: result.msg,
              showConfirmButton: true,
              type: "warning",
              duration: 2000,
              onClose: () => {
                router.app.$api.user
                  .logout(params)
                  .then(res => {
                    let result = res.data
                    //确认前往登录
                    router.app.$router.push({
                      name: "login"
                    })
                  })
                  .catch(err => { })
              },
            })
            return
          }
        }
      }).catch(err => {

      })
    }

  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js